
















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { FilteredFHIRUserPayload } from '../types/admin-fhir-access-management.types';

@Component({
  components: {}
})
export default class FHIRSearchBox extends Vue {
  @Prop(Object) public filterParams!: FilteredFHIRUserPayload;

  private debounceTimer: ReturnType<typeof setTimeout> | null = null;

  @Watch('filterParams.clientName')
  public onClientNameChange() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.$emit('input', this.filterParams);
    }, 500);
  }

  @Watch('filterParams.status')
  public onStatusChange() {
    this.$emit('input', this.filterParams);
  }

  public resetFilter() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
    return this.$emit('resetFilter');
  }
}
